var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.525251 14.0729C0.672356 14.9616 1.44453 15.6394 2.375 15.6394H13.625C14.6605 15.6394 15.5 14.7999 15.5 13.7644V10.1926M0.525251 14.0729C0.508641 13.9725 0.5 13.8695 0.5 13.7644V2.5144C0.5 1.47887 1.33947 0.639404 2.375 0.639404H13.625C14.6605 0.639404 15.5 1.47887 15.5 2.5144V10.1926M0.525251 14.0729L4.10715 10.491C4.74468 9.93314 5.67705 9.87206 6.38191 10.342L6.85921 10.6602C7.5386 11.1131 8.43298 11.0743 9.07058 10.5642L11.5532 8.57808C12.186 8.07185 13.0674 8.03213 13.7401 8.46605C13.8147 8.51414 13.881 8.5737 13.9438 8.63644L15.5 10.1926M7.0625 5.3269C7.0625 6.36244 6.22303 7.2019 5.1875 7.2019C4.15197 7.2019 3.3125 6.36244 3.3125 5.3269C3.3125 4.29137 4.15197 3.4519 5.1875 3.4519C6.22303 3.4519 7.0625 4.29137 7.0625 5.3269Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaWhite);
export default __webpack_public_path__ + "static/media/MediaWhite.480bc706bea2fdbbd79b2484ee32084f.svg";
export { ForwardRef as ReactComponent };